// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_float from "melange.js/caml_float.js";
import * as Caml_int64 from "melange.js/caml_int64.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Infix from "./infix.js";
import * as Ocaml_protoc_plugin__Spec from "./spec.js";
import * as Ocaml_protoc_plugin__Writer from "./writer.js";
import * as Stdlib__ArrayLabels from "melange/arrayLabels.js";
import * as Stdlib__BytesLabels from "melange/bytesLabels.js";
import * as Stdlib__ListLabels from "melange/listLabels.js";
import * as OcamlStringConvert from "ocaml-string-convert";

function field_type(param) {
  if (!/* tag */ (typeof param === "number" || typeof param === "string")) {
    if (param.TAG === /* Message */ 1) {
      return 2;
    } else {
      return 0;
    }
  }
  switch (param) {
    case /* Float */ 1 :
    case /* Fixed32 */ 5 :
    case /* SFixed32 */ 6 :
    case /* Fixed32_int */ 10 :
    case /* SFixed32_int */ 11 :
      return 5;
    case /* Double */ 0 :
    case /* Fixed64 */ 15 :
    case /* SFixed64 */ 16 :
    case /* Fixed64_int */ 20 :
    case /* SFixed64_int */ 21 :
      return 1;
    case /* String */ 23 :
    case /* Bytes */ 24 :
      return 2;
    default:
      return 0;
  }
}

function write_fixed64(f, v) {
  const partial_arg = Curry._1(f, v);
  return function (param) {
    return Ocaml_protoc_plugin__Writer.write_fixed64_value(partial_arg, param);
  };
}

function write_fixed32(f, v) {
  const partial_arg = Curry._1(f, v);
  return function (param) {
    return Ocaml_protoc_plugin__Writer.write_fixed32_value(partial_arg, param);
  };
}

function zigzag_encoding(v) {
  if (Caml.i64_lt(v, Caml_int64.zero)) {
    return Ocaml_protoc_plugin__Infix.Int64.lxor(Ocaml_protoc_plugin__Infix.Int64.lsl(v, 1), Caml_int64.neg_one);
  } else {
    return Ocaml_protoc_plugin__Infix.Int64.lsl(v, 1);
  }
}

function zigzag_encoding_unboxed(v) {
  if (v < 0) {
    return (v << 1) ^ -1;
  } else {
    return (v << 1);
  }
}

function write_varint_unboxed(f, v) {
  const partial_arg = Curry._1(f, v);
  return function (param) {
    return Ocaml_protoc_plugin__Writer.write_varint_unboxed_value(partial_arg, param);
  };
}

function write_value(Enum) {
  if (/* tag */ typeof Enum === "number" || typeof Enum === "string") {
    switch (Enum) {
      case /* Double */ 0 :
        return function (param) {
          return write_fixed64(Caml_int64.bits_of_float, param);
        };
      case /* Float */ 1 :
        return function (param) {
          return write_fixed32(Caml_float.caml_int32_bits_of_float, param);
        };
      case /* Int32 */ 2 :
        return function (param) {
          return write_varint_unboxed((function (prim) {
            return prim;
          }), param);
        };
      case /* UInt32 */ 3 :
        return function (param) {
          return write_varint_unboxed((function (prim) {
            return prim;
          }), param);
        };
      case /* SInt32 */ 4 :
        return function (param) {
          return write_varint_unboxed(zigzag_encoding_unboxed, param);
        };
      case /* Fixed32 */ 5 :
      case /* SFixed32 */ 6 :
        return Ocaml_protoc_plugin__Writer.write_fixed32_value;
      case /* SInt32_int */ 9 :
        return function (param) {
          return write_varint_unboxed(zigzag_encoding_unboxed, param);
        };
      case /* Fixed32_int */ 10 :
        return function (param) {
          return write_fixed32((function (prim) {
            return prim;
          }), param);
        };
      case /* SFixed32_int */ 11 :
        return function (param) {
          return write_fixed32((function (prim) {
            return prim;
          }), param);
        };
      case /* UInt64 */ 12 :
      case /* Int64 */ 13 :
        return Ocaml_protoc_plugin__Writer.write_varint_value;
      case /* SInt64 */ 14 :
        return function (param) {
          const partial_arg = Curry._1(zigzag_encoding, param);
          return function (param) {
            return Ocaml_protoc_plugin__Writer.write_varint_value(partial_arg, param);
          };
        };
      case /* Fixed64 */ 15 :
      case /* SFixed64 */ 16 :
        return Ocaml_protoc_plugin__Writer.write_fixed64_value;
      case /* SInt64_int */ 19 :
        return function (param) {
          return write_varint_unboxed(zigzag_encoding_unboxed, param);
        };
      case /* Fixed64_int */ 20 :
        return function (param) {
          return write_fixed64(Caml_int64.of_int32, param);
        };
      case /* SFixed64_int */ 21 :
        return function (param) {
          return write_fixed64(Caml_int64.of_int32, param);
        };
      case /* Bool */ 22 :
        return function (param) {
          return write_varint_unboxed((function (param) {
            if (param) {
              return 1;
            } else {
              return 0;
            }
          }), param);
        };
      case /* String */ 23 :
        return function (v) {
          const utf8_string = OcamlStringConvert.toFakeUTF8String(v);
          const partial_arg = utf8_string.length;
          return function (param) {
            return Ocaml_protoc_plugin__Writer.write_length_delimited_value(utf8_string, 0, partial_arg, param);
          };
        };
      case /* Bytes */ 24 :
        return function (param) {
          let f = Stdlib__BytesLabels.unsafe_to_string;
          const v = Curry._1(f, param);
          const partial_arg = v.length;
          return function (param) {
            return Ocaml_protoc_plugin__Writer.write_length_delimited_value(v, 0, partial_arg, param);
          };
        };
      default:
        return Ocaml_protoc_plugin__Writer.write_varint_unboxed_value;
    }
  } else {
    if (Enum.TAG === /* Enum */ 0) {
      const Enum$1 = Enum._0;
      return function (param) {
        return write_varint_unboxed(Enum$1.to_int, param);
      };
    }
    const Message = Enum._0;
    return function (param, param$1) {
      return Ocaml_protoc_plugin__Writer.write_length_delimited_f(Message.to_proto$p, param, param$1);
    };
  }
}

function write_field_header(spec, index) {
  const field_type$1 = field_type(spec);
  const header = (index << 3) + field_type$1 | 0;
  let spec$1 = /* Int64_int */ 18;
  const write_value$1 = write_value(spec$1);
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._2(write_value$1, header, writer);
  const partial_arg = Ocaml_protoc_plugin__Writer.contents(writer);
  return function (param) {
    return Ocaml_protoc_plugin__Writer.write_const_value(partial_arg, param);
  };
}

function write_field(spec, index) {
  const write_field_header$1 = write_field_header(spec, index);
  const write_value$1 = write_value(spec);
  return function (writer, v) {
    Curry._1(write_field_header$1, writer);
    Curry._2(write_value$1, v, writer);
  };
}

function write(param) {
  switch (param.TAG) {
    case /* Basic */ 0 :
      const $$default = param._2;
      const write$1 = write_field(param._1, param._0[0]);
      return function (writer, v) {
        if (Caml_obj.caml_equal(v, $$default)) {
          return;
        } else {
          return Curry._2(write$1, writer, v);
        }
      };
    case /* Basic_opt */ 1 :
      const write$2 = write_field(param._1, param._0[0]);
      return function (writer, v) {
        if (v !== undefined) {
          return Curry._2(write$2, writer, Caml_option.valFromOption(v));
        }
        
      };
    case /* Basic_req */ 2 :
      return write_field(param._1, param._0[0]);
    case /* Repeated */ 3 :
      const spec = param._1;
      const index = param._0[0];
      if (param._2 === /* Packed */ 0) {
        const write_value$1 = write_value(spec);
        const write_f = function (writer, vs) {
          Stdlib__ListLabels.iter((function (v) {
            Curry._2(write_value$1, v, writer);
          }), vs);
        };
        const write_header = write_field_header(/* String */ 23, index);
        return function (writer, vs) {
          if (vs) {
            Curry._1(write_header, writer);
            return Ocaml_protoc_plugin__Writer.write_length_delimited_f(write_f, vs, writer);
          }
          
        };
      }
      const write$3 = write_field(spec, index);
      return function (writer, vs) {
        Stdlib__ListLabels.iter((function (v) {
          Curry._2(write$3, writer, v);
        }), vs);
      };
    case /* Map */ 4 :
      const match = param._1;
      const key_spec = match[0];
      const write_header$1 = write_field_header(/* String */ 23, param._0[0]);
      const write_key = write({
        TAG: /* Basic */ 0,
        _0: [
          1,
          "key",
          "key"
        ],
        _1: key_spec,
        _2: Ocaml_protoc_plugin__Spec.default_of_spec(key_spec)
      });
      const write_value$2 = write(match[1]);
      const write_entry = function (writer, param) {
        Curry._2(write_key, writer, param[0]);
        Curry._2(write_value$2, writer, param[1]);
      };
      return function (writer, vs) {
        Stdlib__ListLabels.iter((function (v) {
          Curry._1(write_header$1, writer);
          Ocaml_protoc_plugin__Writer.write_length_delimited_f(write_entry, v, writer);
        }), vs);
      };
    case /* Oneof */ 5 :
      const match$1 = param._0;
      const index_f = match$1[1];
      const create_writer = function (param) {
        const destructor = param._2[1];
        const write$4 = write({
          TAG: /* Basic_req */ 2,
          _0: param._0,
          _1: param._1
        });
        return function (writer, v) {
          Curry._2(write$4, writer, Curry._1(destructor, v));
        };
      };
      const field_writers = Stdlib__ArrayLabels.of_list(Stdlib__ListLabels.map(create_writer, match$1[0]));
      return function (writer, v) {
        if (v === "not_set") {
          return;
        }
        const index = Curry._1(index_f, v);
        const write = field_writers[index];
        Curry._2(write, writer, v);
      };
  }
}

function in_extension_ranges(extension_ranges, index) {
  return Stdlib__ListLabels.exists((function (param) {
    if (Caml_obj.caml_greaterequal(index, param[0])) {
      return Caml_obj.caml_lessequal(index, param[1]);
    } else {
      return false;
    }
  }), extension_ranges);
}

function serialize(extension_ranges) {
  if (/* tag */ typeof extension_ranges === "number" || typeof extension_ranges === "string") {
    return function (_writer) {
      
    };
  }
  if (extension_ranges.TAG === /* Nil_ext */ 0) {
    const extension_ranges$1 = extension_ranges._0;
    return function (writer, extensions) {
      Stdlib__ListLabels.iter((function (param) {
        const index = param[0];
        if (in_extension_ranges(extension_ranges$1, index)) {
          return Ocaml_protoc_plugin__Writer.write_field(writer, index, param[1]);
        }
        
      }), extensions);
    };
  }
  const cont = serialize(extension_ranges._1);
  const write$1 = write(extension_ranges._0);
  return function (writer, v) {
    Curry._2(write$1, writer, v);
    return Curry._1(cont, writer);
  };
}

export {
  serialize,
}
/* Ocaml_protoc_plugin__Spec Not a pure module */
